import { captureOwnerStack } from "react";
import { useNavigate } from "react-router-dom";

function CollapseDetails({ object, roles, userObject }) {
  const navigate = useNavigate();

  const fields = [
    {
      label: "Business Type",
      value: object?.businessType || "",
    },
    {
      label: "Contact Number",
      value: object?.contactNo || "",
    },
  ];

  const isAdmin = roles.some((role) => role.id === "Admin");

  return (
    <div className="d-flex flex-column">
      {fields.map((field, index) => {
        return (
          <div className="d-flex gap-1" key={index}>
            <label className="fw-bold text-muted">{field.label} :</label>
            <p className="m-0">{field.value}</p>
          </div>
        );
      })}

      <div className="d-flex gap-2 mt-2">
        <button
          className="btn text-white text-center fw-bold bg-primary"
          onClick={() => navigate(`/clients/form/${object?.id}`)}
        >
          <i className="bi bi-pencil me-2"></i>
          Edit
        </button>

        {/* <button
          className="btn btn-danger btn-md col-3 col-md-2 col-lg-1 text-center"
          onClick={onDelete}
        >
          <i className="bi bi-trash me-2"></i>
          Delete
        </button> */}
        {isAdmin && !userObject?.id && (
          <>
            <button
              className="btn btn-light text-center fw-bold"
              style={{ backgroundColor: "#ffde50" }}
              onClick={() => navigate(`/employees/${object?.id}`)}
            >
              <i className="bi bi-people me-2"></i>
              Employees
            </button>

            {/* <button
              className="btn btn-light text-center fw-bold"
              style={{ backgroundColor: "#8bc34a" }}
              onClick={() => navigate(`/clients/list/${object?.id}`)}
            >
              <i className="bi bi-people me-2"></i>
              Clients
            </button> */}
            {/* <button
              className="btn btn-light text-center fw-bold"
              style={{ backgroundColor: "#9ad853" }}
              onClick={_onViewDashboard}
            >
              <i className="bi bi-speedometer2 me-2"></i>
              Dashboard
            </button> */}
          </>
        )}
      </div>
    </div>
  );
}

export default CollapseDetails;
